export default __webpack_public_path__ + "static/media/Giuseppe Cederna (1).c3c7f69e.jpg";